
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const mentorshipMasterService = createApi({
    reducerPath: 'mentorshipMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Mentorship'],
    endpoints: (builder) => ({
        getAllMentorshipMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.getAllMentorshipMasterWithPagination}/${body.page}/${body.size}?orderBy=${body.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getMentorshipMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.getMentorshipMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveMentorshipMaster: builder.mutation({
            query(body) {
                // Check if payload is FormData (for file uploads)
                const isFormData = body.payload instanceof FormData;
                return {
                    url: `${userManagement.mentorshipMasterController.saveMentorshipMaster}`,
                    method: 'POST',
                    headers: isFormData
                        ? { Authorization: `Bearer ${body.token}` } // Let browser set Content-Type with boundary for FormData
                        : {
                            Authorization: `Bearer ${body.token}`,
                            'Content-Type': 'application/json'
                        },
                    body: body.payload,
                }
            }
        }),
        updateMentorshipMaster: builder.mutation({
            query(body) {
                // Check if payload is FormData (for file uploads)
                const isFormData = body.payload instanceof FormData;
                return {
                    url: `${userManagement.mentorshipMasterController.updateMentorshipMaster}/${body.id}`,
                    method: 'PUT',
                    headers: isFormData
                        ? { Authorization: `Bearer ${body.token}` } // Let browser set Content-Type with boundary for FormData
                        : {
                            Authorization: `Bearer ${body.token}`,
                            'Content-Type': 'application/json'
                        },
                    body: body.payload,
                }
            }
        }),
        deleteMentorshipMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.deleteMentorshipMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllMentorshipMasterBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.getAllMentorshipMasterBySearch}`,
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${body.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: body.payload,
                };
            },
        }),
        findAllMentorshipMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.findAllMentorshipMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveMentorshipMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.bulkSaveMentorshipMaster}`,
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${body.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: body.payload,
                }
            }
        }),
        downloadMentorship: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.mentorshipMasterController.downloadMentorship}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                    responseHandler: (response) => response.blob(),
                    responseType: 'blob',
                }
            }
        }),
    })
});

export const {
    useGetAllMentorshipMasterMutation,
    useGetMentorshipMasterByIdMutation,
    useSaveMentorshipMasterMutation,
    useUpdateMentorshipMasterMutation,
    useDeleteMentorshipMasterMutation,
    useGetAllMentorshipMasterBySearchMutation,
    useFindAllMentorshipMasterMutation,
    useBulkSaveMentorshipMasterMutation,
    useDownloadMentorshipMutation
} = mentorshipMasterService;
